<template>
<p>
Heads up! This wallet is a prototype and all data is for demonstration purposes
only. We would love your feedback on you experience, please join us on
<lnk @click="telegramClicked" href="https://t.me/hirevibes_dapp">Telegram</lnk>
 or email:
<a @click="feedbackClicked" href="mailto:feedback@hirevibes.io">feeback@hirevibes.io</a>
</p>
</template>

<script>
import Lnk from '@/components/general/link'
export default {
  components: { Lnk },
  methods: {
    feedbackClicked () {
      this.$ga.event('Feedback', 'Clicked')
    },
    telegramClicked () {
      this.$ga.event('Telegram', 'Clicked')
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/components/prototype/prototype-info.vue